'use client'

import React from 'react'
import {
  ChevronDownIcon,
  ArrowRightIcon,
  XMarkIcon,
  CheckIcon,
  PhoneIcon,
  BoltIcon,
  ArrowPathIcon,
  Square3Stack3DIcon,
  ShieldExclamationIcon,
  ShieldCheckIcon,
  ChartBarIcon,
  GlobeAltIcon,
  CircleStackIcon,
  LifebuoyIcon,
  CodeBracketIcon,
  ServerIcon,
  ArrowsRightLeftIcon,
  AdjustmentsHorizontalIcon,
  BuildingOfficeIcon,
  LightBulbIcon,
  CubeIcon,
  CreditCardIcon,
  ClipboardDocumentIcon,
  ComputerDesktopIcon,
  ClockIcon,
  UserIcon,
  CheckCircleIcon,
  RectangleGroupIcon,
  Squares2X2Icon,
  CurrencyDollarIcon,
  SquaresPlusIcon,
  BellIcon,
  DocumentIcon,
  CloudIcon,
  EnvelopeIcon,
  UsersIcon,
  VideoCameraIcon,
  ServerStackIcon,
  CloudArrowUpIcon,
  CpuChipIcon,
  PlayIcon,
  PlusIcon,
} from '@heroicons/react/24/outline'

const SentryIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 -14.5 256 256" fill="currentColor" stroke="none" {...props}>
    <path d="M148.367708,12.4025287 C144.036807,5.21480737 136.258026,0.820118864 127.866362,0.820118864 C119.474697,0.820118864 111.695916,5.21480737 107.365016,12.4025287 L73.6403017,70.165071 C126.066153,96.3390588 160.689085,148.341727 164.615024,206.806542 L140.93597,206.806542 C137.017513,156.694333 106.874845,112.396698 61.6982677,90.3588968 L30.4849684,144.32869 C55.8497707,155.704426 73.6778379,179.211206 77.7918243,206.704035 L23.4120041,206.704035 C22.1018479,206.611361 20.9266153,205.864669 20.2861278,204.71799 C19.6456403,203.571311 19.6261529,202.179068 20.2342955,201.014912 L35.3027847,175.388229 C30.1976229,171.128798 24.3630321,167.829476 18.0816541,165.65009 L3.16692493,191.276772 C0.0305635285,196.656417 -0.818661742,203.068719 0.809210488,209.079324 C2.43708272,215.08993 6.40620885,220.197261 11.8287436,223.258872 C15.3657216,225.251729 19.3523095,226.310116 23.4120041,226.334074 L97.8831433,226.334074 C100.696274,191.620878 85.1423372,157.966047 56.8804514,137.614499 L68.7199787,117.113153 C104.398813,141.618242 124.473737,183.151896 121.510945,226.334074 L184.603837,226.334074 C187.593899,160.904124 155.557278,98.8221906 100.497065,63.3483734 L124.432386,22.3456815 C125.542508,20.4856859 127.944329,19.8680747 129.81399,20.9618406 C132.530418,22.4481882 233.807067,199.169791 235.703442,201.219925 C236.383476,202.439289 236.358897,203.929352 235.639016,205.125624 C234.919136,206.321896 233.614065,207.041397 232.218213,207.011555 L207.821611,207.011555 C208.129131,213.537817 208.129131,220.046994 207.821611,226.539592 L232.32072,226.539592 C238.604421,226.580218 244.643414,224.105731 249.091568,219.667205 C253.539722,215.228679 256.027289,209.195062 256,202.911286 C256.002825,198.802186 254.905596,194.767215 252.822066,191.225519 L148.367708,12.4025287 Z" />
  </svg>
)

const TelegramIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="currentColor" stroke="none" {...props}>
    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.16.18-.357.223-.548.223l.188-2.85 5.18-4.686c.223-.195-.054-.31-.346-.11l-6.4 4.02-2.76-.86c-.6-.185-.613-.6.125-.89l10.736-4.13c.498-.184.94.11.825.811z" />
  </svg>
)

const icons = {
  'chevron-down': ChevronDownIcon,
  'arrow-right': ArrowRightIcon,
  close: XMarkIcon,
  check: CheckIcon,
  phone: PhoneIcon,
  lightning: BoltIcon,
  refresh: ArrowPathIcon,
  layers: Square3Stack3DIcon,
  shield: ShieldExclamationIcon,
  'shield-check': ShieldCheckIcon,
  'chart-bar': ChartBarIcon,
  globe: GlobeAltIcon,
  database: CircleStackIcon,
  support: LifebuoyIcon,
  code: CodeBracketIcon,
  server: ServerIcon,
  transfer: ArrowsRightLeftIcon,
  adjustments: AdjustmentsHorizontalIcon,
  building: BuildingOfficeIcon,
  lightbulb: LightBulbIcon,
  container: CubeIcon,
  'credit-card': CreditCardIcon,
  clipboard: ClipboardDocumentIcon,
  monitor: ComputerDesktopIcon,
  clock: ClockIcon,
  user: UserIcon,
  'check-circle': CheckCircleIcon,
  collection: RectangleGroupIcon,
  grid: Squares2X2Icon,
  'currency-dollar': CurrencyDollarIcon,
  apps: SquaresPlusIcon,
  bell: BellIcon,
  document: DocumentIcon,
  cloud: CloudIcon,
  email: EnvelopeIcon,
  users: UsersIcon,
  sentry: SentryIcon,
  telegram: TelegramIcon,
  'video-camera': VideoCameraIcon,
  'server-stack': ServerStackIcon,
  s3: CloudArrowUpIcon,
  gpu: CpuChipIcon,
  play: PlayIcon,
  plus: PlusIcon,
}

export type IconName = keyof typeof icons

interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName
  className?: string
  strokeWidth?: number | string
}

export default function Icon({ name, className = 'w-4 h-4', strokeWidth = 2, ...props }: IconProps) {
  const IconComponent = icons[name]
  if (!IconComponent) return null

  return <IconComponent className={className} strokeWidth={strokeWidth} {...props} />
}
